import { createReducer } from "@reduxjs/toolkit";
import { typePagination } from "../system/constants";
import { logoutAC, resetReducers } from "../system/systemActionCreators";
import {
  dRefundsArchiveSetDataAC,
  dRefundsArchiveSetFiltersAC,
  dRefundsArchiveClearFiltersAC,
  dRefundsArchiveSetDetailItemAC,
  dRefundsArchiveSetPageNumberAC,
  dRefundsArchiveSetPaginationAC,
  dRefundsArchiveSetItemsForPageAC,
  dRefundsArchiveSetDetailItemFromSalesAC,
} from "./actionCreators";

export type IdRefundsArchiveState = {
  pagination: typePagination;
  filters: typeRefundsArchiveFilters;
  data: IdRefundsArchiveStateDataItem[];
  detailItem: IdRefundsArchiveStateDataItem | undefined;
};

export type typeRefundsArchiveFilters = {
  receiptNumber?: string | null;
  date?: { to: string | null; from: string | null } | null;
};

export type IdRefundsArchiveStateDataItem = {
  id: string;
  date: string;
  fmId: string;
  userId: string;
  amount: number;
  orderId: string;
  userName: string;
  cashierId: string;
  fiscalSign: string;
  appletVersion: string;
  zreportNumber: string;
  receiptNumber: string;
  payments: {
    id: string;
    date: string;
    method: string;
    amount: number;
    paymentType: string;
    paymentAmount: number;
    transactionNumber: number;
    paymentTransactionValue: number;
    paymentInfo: {
      rrn: string;
      stan: string;
      authCode: string;
      terminalId: string;
      merchantId: string;
      responseCode: string;
      paymentSystemName: string;
      transactionNumber: number;
    };
  }[];
  productList: {
    id: string;
    tax: number;
    psid: string;
    price: number;
    amount: number;
    marked: boolean;
    unitCode: number;
    productId: string;
    barcodes: string[];
    customTotal: number;
    packageCode: string;
    productName: string;
    commissionTIN: string;
    discountAmount: number;
    markedLabels: string[];
    commissionPINFL: string;
    productOwnerType: string;
    product?: {
      vat: number;
      name: string;
      psid: string;
      units: string;
    };
  }[];
  store: {
    id: string;
    name: string;
    email: string;
    address: string;
    manager: string;
    deleted: boolean;
    externalId: string;
    industryId: string;
    phoneNumber: string;
    description: string;
    interfaceType: string;
    managerPhoneNumber: string;
    externalSystemCode: string;
  };
};

export const initialState: IdRefundsArchiveState = {
  data: [],
  detailItem: undefined,
  filters: {
    date: null,
    receiptNumber: null,
  },
  pagination: {
    pageNumber: 0,
    itemsPerPage: 14,
  },
};

export const DRefundsArchiveReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(dRefundsArchiveSetDataAC, (state, action) => {
      state.data = action.payload.dataList;
    })
    .addCase(dRefundsArchiveSetPaginationAC, (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload.pagination };
    })
    .addCase(dRefundsArchiveSetItemsForPageAC, (state, action) => {
      state.pagination = {
        ...state.pagination,
        pageNumber: 0,
        itemsPerPage: action.payload.itemsForPage,
      };
    })
    .addCase(dRefundsArchiveSetPageNumberAC, (state, action) => {
      state.pagination.pageNumber = action.payload.pageNumber;
    })
    .addCase(dRefundsArchiveSetDetailItemAC, (state, action) => {
      state.detailItem = state.data.find((item) => item.id === action.payload);
    })
    .addCase(dRefundsArchiveSetDetailItemFromSalesAC, (state, action) => {
      state.detailItem = action.payload;
    })
    .addCase(dRefundsArchiveClearFiltersAC, (state) => {
      state.filters.date = null;
      state.filters.receiptNumber = null;
    })
    .addCase(dRefundsArchiveSetFiltersAC, (state, action) => {
      state.filters = { ...state.filters, ...action.payload };

      state.pagination.pageNumber = 0;
    })
    .addCase(logoutAC, (state) => {
      state.data = initialState.data;
      state.filters = initialState.filters;
      state.detailItem = initialState.detailItem;
      state.pagination = initialState.pagination;
    })
    .addCase(resetReducers, (state, action) => {
      if (action.payload !== "refunds") {
        state.data = initialState.data;
        state.filters = initialState.filters;
        state.pagination = initialState.pagination;
        state.detailItem = initialState.detailItem;
      }
    });
});
